"use strict";

export function initInScope ($scope) {

    let $fakeSelectContainer = $scope.find('.js-fake-select'),
        $fakeSelect = $fakeSelectContainer.find('.js-fake-select__select'),
        $fakeSelectTarget = $fakeSelectContainer.find('.js-fake-select__target');

    $fakeSelect.on('change', function (e) {
        let $target = $($(this).val());
        $fakeSelectTarget.prop('hidden', true);
        $target.prop('hidden', false);
    });

}